import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'

Vue.use(Vuex)

const state = {
      imgUrl:'',//上传图片地址
      newList:'',//存储新闻内容
}


export default new Vuex.Store({
    state: sessionStorage.getItem('state') ? 
	JSON.parse(sessionStorage.getItem('state')) : {
    ordergoods: {}
    },
    getters,
    actions,
    mutations,
})


// WEBPACK FOOTER //
// ./src/store/index.js